import React, { useState, useEffect } from "react";
import { useDispatch, useSelector} from "react-redux";
import { useNavigate } from "react-router-dom";
import { unwrapResult } from "@reduxjs/toolkit";
import { Button, Tbody, Td, Th, Thead, Tr, Select, Box , Switch} from "@chakra-ui/react";
import { ChevronRightIcon } from "@chakra-ui/icons";
import { getOfficeWeek,updateWeekStatus } from "../../features/week/officeWeekSlice";
import Spinner from "../../components/FormElements/Spinner";
import { AlertDialog } from "../../components/UIElements/AlertDialog";
import { HoverableTable } from "../../components/UIElements/HoverableTable";
import { ADMIN_ROUTES } from "../../config/routes";

export const OfficeWeekView = ({selectedYear, locationId }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate(); // Initialize useNavigate
  const currentYear = new Date().getFullYear();

  const [year, setYear] = useState(selectedYear ? selectedYear : currentYear);
  const [avaialableYears, setAvailableYears] = useState([currentYear]);


  const { officeWeek, isLoading, isError } = useSelector(
    (state) => state.officeWeek
  );

  useEffect((prevSelectedYear) => {
    if(selectedYear && prevSelectedYear !== selectedYear) {
      setYear(selectedYear);
    }
  }, [selectedYear])

  useEffect(() => {
    dispatch(getOfficeWeek(locationId))
      .then(unwrapResult)
      .then(result => {
        const uniqueYears = [...new Set(result.map(item => new Date(item.week_starting_date).getFullYear()))];
        setAvailableYears([...uniqueYears]);
        if (!uniqueYears.includes(Number(year))) {
          if (uniqueYears.length > 0) {
            setYear(uniqueYears.includes(Number(currentYear)) ? currentYear : uniqueYears[0]);
          }
        }
      })
      .catch((error) => {
        console.error("GetOfficeWeek Dispatch ", error);
      });
  }, [dispatch, locationId]);

  const getStudentList = (date, locationID) => {
    const searchParams = new URLSearchParams({ 
      weekStartingDate: date.week_starting_date, 
      locationId: locationID
    });
    navigate(`${ADMIN_ROUTES.weekView}?${searchParams.toString()}`);
  };


  // Filter office weeks based on the selected year
  const filteredOfficeWeek = officeWeek.filter((week) =>
    new Date(week.week_starting_date).getFullYear() === parseInt(year)
  );

  const handleToggleWeek = (week) => {
    // Create a new object with the updated enabled/disabled state
    const updatedWeek = { ...week, is_available: week.is_available === true ? 0 : 1 };
  
    // Dispatch action or make API call to save the new state
    dispatch(updateWeekStatus(updatedWeek))
      .then((response) => {
        if (response.meta.requestStatus === 'fulfilled') {
          // Successfully updated week status in backend
          console.log('Week status updated', response.payload);
        } else {
          // Handle the error
          console.error('Failed to update week status', response.payload);
        }
      })
      .catch((error) => {
        console.error('Error updating week status:', error);
      });
  };
  


  if (isLoading) return <Spinner />;
  if (isError)
    return <AlertDialog variant="error" message="Error loading office week" />;

  return (
        <>
          {/* Year Dropdown */}
          <Box display="flex" justifyContent="flex-end" mb={4}>
            <Select
              placeholder="Select Year"
              value={year}
              onChange={(e) => setYear(e.target.value)}
              width="200px"
               color="red.500"
            >
             {avaialableYears.map((yr) => (
        <option key={yr} value={yr}>
          {yr}
        </option>
      ))}
            </Select>
          </Box>

          {/* Office Week Table */}
        <HoverableTable>
          <Thead>
            <Tr>
              <Th>Week Startdate</Th>
              <Th>Week Enddate</Th>
              <Th>Places Available</Th>
              <Th>Max Places</Th>
              <Th>Action</Th>
              <Th>Week Status</Th>
            </Tr>
          </Thead>
          <Tbody>
            {filteredOfficeWeek.map((officeWeek) => (
              <Tr
                key={officeWeek.date_key}
                className={officeWeek.week_starting_date ? "selected" : ""}
              >
                <Td>{officeWeek.week_starting_date}</Td>
                <Td>{officeWeek.week_ending_date}</Td>
                <Td>{officeWeek.available_spaces}</Td>
                <Td>{officeWeek.max_students}</Td>
                <Td>
                  <Button
                    variant="link"
                    onClick={() =>
                      getStudentList(officeWeek, locationId)
                    }
                    rightIcon={<ChevronRightIcon ml="-5px" mt="4px" />}
                    colorScheme="red"
                  >
                    Student List
                  </Button> 
                  </Td>
                  <Td>
                  <Switch
                  ml="10px"
                    isChecked={officeWeek.is_available===true}
                    onChange={() => handleToggleWeek(officeWeek)}
                    colorScheme="red"
                  />   
                </Td>
              </Tr>
            ))}
          </Tbody>
        </HoverableTable>
    </>
  );
};
